import { styled } from "@stitches/react";
import { Link, useLocation } from "react-router-dom";
import navItems from "./nav.json";
import {
  MultiselectChangeEvent,
  SingleSelect,
  StructuredOption,
} from "@/vendor/Forge/dist";
import { useAppState } from "@/contexts/app-state";
import { useUsers } from "@/hooks/use-users";
import { useEffect } from "react";

interface NavItem {
  id: string;
  text: string;
  href: string;
}

const Nav = styled("nav", {
  display: "flex",
  alignItems: "center",
  height: "100%",
  justifyContent: "space-between",

  "& > ul": {
    margin: "0 24px",
  },
});

const List = styled("ul", {
  display: "flex",
  listStyleType: "none",
  gap: 40,

  "& > li": {
    fontSize: 16,
    lineHeight: "20px",
  },
  "& > li.active": {
    borderBottom: "1px solid #043961",
  },
  "& > li.active > a": {
    color: "#043961",
  },
});

const User = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  gap: 4,
  width: 250,

  "& > label": {
    color: "#5D5E5E",
    fontSize: 14,
  },
});

const MainNav = () => {
  const location = useLocation();
  const { currentUser, loggedInUser, updateAppState } = useAppState();
  const { data: users = [], isPending, refetch } = useUsers();
  const isInMyTasks = location.pathname === "/my-tasks";
  const excludeBucketInHeader = location.pathname === "/user-activity" || location.pathname.includes("/tao-routing");

  useEffect(() => {
    if (!currentUser && users.length > 0)
      updateAppState({
        currentUser: users[0],
      });
  }, [users, currentUser, updateAppState]);

useEffect(() => {
  const interval = setInterval(() => {
    void refetch();
  }, 1140000); // 19 minutes

  return () => clearInterval(interval);
}, [refetch]);

  return (
    <Nav>
      <List>
        {navItems.map((nav: NavItem) => (
          <li
            key={nav.id}
            className={location.pathname.includes(nav.href) ? "active" : undefined}
          >
            <Link to={nav.href}>{nav.text}</Link>
          </li>
        ))}
      </List>
      {!excludeBucketInHeader ?
        <User>
          <label htmlFor="current-user-select">
            Current {isInMyTasks ? "User" : "Bucket"}
          </label>
          <SingleSelect
            inputId="current-user-select"
            disabled={isPending || isInMyTasks}
            options={users}
            value={isInMyTasks ? loggedInUser : currentUser}
            onChange={(e: MultiselectChangeEvent<StructuredOption, false>) => {
              const selected = e.target.value;
              return updateAppState({
                currentUser: selected?.value,
              });
            }}
          />
        </User>
        :
        <></>
      }
    </Nav>
  );
};

export default MainNav;
